window.addEventListener("DOMContentLoaded", function () {
  jQuery(function ($) {
    window.Medispa.carousels["partners"] = new Swiper(
      ".partner-logos-carousel",
      {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 24,
        slidesOffsetAfter: 48,
        navigation: {
          nextEl: ".partner-logos-carousel .swiper-button-next",
        },
        allowTouchMove: true,
        breakpoints: {
          1139: {
            spaceBetween: 40,
          },
        },
      },
    );

    function showStickyBookingNow() {
      var isMobile = $(window).outerWidth() < 768;

      var lastScrollTop = 0;
      var atcBtn = $(".hero-banner-content-wrapper .booking-wrapper").get(0);

      $(window).on("resize", function (e) {
        isMobile = $(window).outerWidth() < 768;
      });

      $(window).on("scroll", function (e) {
        var scrollTop = $(this).scrollTop();
        lastScrollTop = scrollTop;
        // Additional offset to use for edges of screen to determine visibility
        var screenGutter = 20;
        var atcOffScreen = atcBtn.getBoundingClientRect().top <= 0;
        var atcOnScreen =
          atcBtn.getBoundingClientRect().top <=
            $(window).outerHeight() - screenGutter &&
          atcBtn.getBoundingClientRect().top > 0 + screenGutter;

        var shouldHideSubnav =
          (!isMobile && !atcOffScreen) || (isMobile && atcOnScreen);

        $(".sticky-booking").toggleClass("hide", shouldHideSubnav);
      });

      // Start with sticky ATC visible on mobile
      if (isMobile) {
        $(".sticky-booking").toggleClass("hide", false);

        $(".sticky-booking .overlay").on("click", function () {
          $(".sticky-booking .booking-wrapper").removeClass("open");
          $(".sticky-booking .medispa-dropdown-trigger").removeClass("open");
        });
      }
    }

    showStickyBookingNow();

    // show klavyio popup after 10 seconds
    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function showKlavyioPopup() {
      var screenSize = $(window).outerWidth();

      if (screenSize < 768) {
        setTimeout(function () {
          const userViewPopup = getCookie("view_klavyio_popup_mobile");
          if (!userViewPopup) {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(["openForm", window.Medispa.offersPopupConfig.offer_id_mobile]);
            setCookie("view_klavyio_popup_mobile", true, 5);
          }
        }, 10000);
      } else {
        setTimeout(function () {
          const userViewPopup = getCookie("view_klavyio_popup_desktop");
          if (!userViewPopup) {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(["openForm", window.Medispa.offersPopupConfig.offer_id_desktop]);
            setCookie("view_klavyio_popup_desktop", true, 5);
          }
        }, 10000);
      }
    }

    showKlavyioPopup();
  });
});
